export var actionTypePrefix = '@@UserAvatarPopover';
export var reduxKey = '@@UserAvatarPopover';
//# sourceMappingURL=constants.js.map